import * as React from 'react';
import { useContext } from 'react';
import '../../../styles/UnitMap.css';
import { MapContext } from './UnitMapTypes';

interface LegendProps {
    title: string;
}

const Legend = (props: LegendProps) => {
    const context = useContext(MapContext);
    return (
        <div className={'d-flex flex-column legend'}>
            <h5>{props.title}</h5>
            <div className={'d-flex px-2'}>
                <div className={'color-circle tour24-stop'} />
                <div>Tour24 Stops</div>
            </div>
            <div className={'d-flex px-2'}>
                <div className={'color-circle amenity'} />
                <div>Amenity</div>
            </div>
            <hr className="legend-divider" />
            {context.colors.map(unitColor => {
                return (
                    <div key={unitColor.id}>
                        <div className={'d-flex px-2'}>
                            <div
                                className={'color-square'}
                                style={{ backgroundColor: `#${unitColor.hexColor}` }}
                            />
                            <div>{unitColor.label}</div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Legend;



// WEBPACK FOOTER //
// ./src/components/common/UnitMap/Legend.tsx